import { ChangeDetectorRef, Component, EventEmitter, HostBinding, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { Subscription } from 'rxjs';
import { GlobalModel } from '../../../../services/state/global.model';
import { LoggerService } from '../../../../services/logger/logger.service';
import { TriState } from '../../../commonUI/button/lumi-tristate-button/lumi-tristate-button.component';
import {FormEvent} from "../../containers/form/form.interface";
import {HTTPService} from "../../../../services/http/http.service";
import {GlobalAlertService} from "../../../../../wrapper/global-alert/global-alert.service";
import {TranslateService} from "../../../../services/translate/translate.service";

@Component({
  selector: 'form-tri-state-button,form-three-state-switch',
  template: `
    <div *ngIf="isVisible()" class="dynamic-field" [formGroup]="group">
      <lumi-tristate-button
          [fullWidth]="true"
          offLabel="0% Override"
          autoLabel="Auto"
          onLabel="100% Override"
          compactSuffix="Override"
          [(state)]="state"
          (stateChange)="handleStateChange($event)"
      />
    </div>
  `
})
export class FormTriStateButtonComponent implements OnInit, OnDestroy {
  @HostBinding('class') hostClasses = 'default-button-container';

  @Output() onComponentEvent: EventEmitter<FormTriStateButtonEvent> = new EventEmitter();

  @Input() group: UntypedFormGroup;
  @Input() readOnly: boolean;
  @Input() invalidControlsErrors: any;

  private _config: any;
  private _subMobileMode: Subscription;
  private _mobileMode: boolean = false;

  // Current selected state
  @Input() state: TriState = 'off';

  constructor(private model: GlobalModel,
              private cd: ChangeDetectorRef,
              protected logger: LoggerService,
              private httpService:HTTPService,
              private globalAlert:GlobalAlertService,
              private ts:TranslateService) {}

  ngOnInit(): void {
    this._subMobileMode = this.model.mobileMode.subscribe((value: boolean) => {
      this._mobileMode = value;
      this.cd.detectChanges();
    });
  }

  ngOnDestroy(): void {
    if (this._subMobileMode) {
      this._subMobileMode.unsubscribe();
    }
  }

  @Input()
  set config(value: any) {
    this._config = value;
    // Initial state from config.initialValue if present
    if (this._config && typeof this._config.initialValue === 'string') {
      const iv = this._config.initialValue as TriState;
      if (iv === 'off' || iv === 'auto' || iv === 'on') {
        this.state = iv;
      }
    }
    // Host classes alignment (reuse defaults from form-button where sensible)
    this.hostClasses = 'default-button-container';
  }

  get config(): any {
    return this._config;
  }

  isVisible(): boolean {
    // Mirror form-button visibility: currently only hides cancel on mobile, which we don't have
    return true;
  }

  isDisabled(): boolean {
    let disabled = false;

    if (this.readOnly === true) {
      disabled = true;
    } else if (this.readOnly === false) {
      disabled = false;
    }

    if (this.config && this.config.disabled === true) {
      disabled = true;
    }

    if (this.config && this.config.disabledByFormError) {
      disabled = true;
    }

    return disabled;
  }

  handleClick(): void {

    // Purely for parity with form-button to signal an interaction occurred
    this.emitComponentEvent(false);
  }

  handleStateChange(next: TriState): void {
    this.state = next;
    this.emitComponentEvent(true);
    this.sendOverride();
  }

  getToolTip(): string {
    return (this.config && this.config.attr && this.config.attr.toolTip) ? this.config.attr.toolTip : '';
  }

  private emitComponentEvent(valueChanged: boolean): void {
    const payload: FormTriStateButtonEvent = {
      state: this.state,
      valueChanged,
      doVisibleCheck: this.config && this.config.attr ? !!this.config.attr.doVisibleCheck : false
    };
    this.onComponentEvent.emit(payload);
  }

  private sendOverride() {
    let url = '';


    if (this.config.attr && this.config.attr.url){
      url = this.config.attr.url
    }
    if (this.config.attr && this.config.attr.url && this.config.attr.baseObjectId){
      url = this.config.attr.url + '/' + this.state + '/' + this.config.attr.baseObjectId
    }
    if (url !== ''){
      this.httpService.doPostRequest(url,
          this.state,
          (json: any) => {
            // wordt er een bericht met een message mee gestuurd (title, subtitle, text), toon dan deze!
            if (json.message && json.message.title && json.message.subtitle && json.message.text) {
              this.globalAlert.addAlertSuccess(json.message.title, json.message.subtitle, json.message.text);
            } else {
              this.globalAlert.addAlertSuccess(this.ts.translate('inlinebutton.success.title'), this.ts.translate('inlinebutton.success.subtitle'), this.ts.translate('inlinebutton.success.text'));
            }
          },
          () => {
          });
    }
  }

}

export interface FormTriStateButtonEvent {
  state: TriState;
  valueChanged: boolean;
  doVisibleCheck?: boolean;
}
